import { t as e } from "./cx-BjmrJCen.js";
/* empty css                              */
import { t } from "./text.css-DDuHJ-lZ.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/empty-state/empty-state.css.ts
var i = "_1qyha080", a = "_1qyha081";
//#endregion
//#region src/components/empty-state/empty-state.tsx
function o({ children: o, className: s, title: c, ...l }) {
	return /* @__PURE__ */ r("section", {
		...l,
		className: e(i, s),
		children: [/* @__PURE__ */ n("p", {
			className: a,
			children: c
		}), o ? /* @__PURE__ */ n("span", {
			className: t,
			children: o
		}) : null]
	});
}
//#endregion
export { o as EmptyState };

//# sourceMappingURL=empty-state.js.map